export const PREVIOUS = { en: 'Previous', th: 'ก่อนหน้า' }
export const NEXT = { en: 'Next', th: 'ถัดไป' }
